<template>
    <div class="select_coupon_wrap">
        <div class="fc ac">
            <div v-show="couponList.length" class="fc ac">
                <h3 class="title">可用优惠券</h3>
                <div
                    @click="selectCoupon(index)"
                    v-for="(item, index) in couponList"
                    :key="item.cardno"
                    class="couponItem"
                >
                    <div v-show="item.is_selected" class="selectedIco center">
                        <img
                            src="../../../static/imgs/movie/duigou_white.png"
                            alt
                        />
                    </div>
                    <div class="itemInfo fr ac jsb">
                        <div class="fc">
                            <span>{{ item.amount }}元优惠券</span>
                            <span class="grey"
                                >有效日期至：{{ item.enddate }}</span
                            >
                        </div>
                        <span class="status tc">已激活</span>
                    </div>
                </div>
            </div>
            <div v-show="invalidCouponList.length" class="fc ac">
                <h3 class="title">不可用优惠券</h3>
                <div
                    class="invalid_coupon fc"
                    v-for="(item, index) in invalidCouponList"
                    :key="item.cardno"
                >
                    <div class="coupon_item">
                        <img
                            class="invalid_icon"
                            src="../../../static/imgs/movie/coupon_invalid.png"
                            alt=""
                        />
                        <div class="fc jc">
                            <span class="grey">{{ item.amount }}元优惠券</span>
                            <span class="grey">有效日期至：{{ item.enddate }}</span>
                        </div>
                    </div>
                    <div class="coupon_footer">{{ item.unusedReason }}</div>
                </div>
            </div>
        </div>
        <div class="footer fr ac jsb">
            <span>已选中{{ selectedCouponNum }}张优惠券</span>
            <div class="center" @click="useCoupon">确定</div>
        </div>
    </div>
</template>

<script>
import { Toast } from "mint-ui";
export default {
    data() {
        return {
            tradeno: this.$route.query.tradeno,
            couponList: [],
            invalidCouponList: [],
            selectedCouponArr: [],
            ticketNum: this.$route.query.ticketNum
                ? this.$route.query.ticketNum
                : 0,
            selectedCouponNum: 0,
        };
    },
    components: {},
    created() {
        // this.getCouponInfo();
        Promise.all([this.getOrderInfo(), this.getCouponInfo()])
            .then((result) => {
                if (
                    this.orderInfo.items &&
                    this.orderInfo.items.length > 1 &&
                    this.couponList.length
                ) {
                    for (let i of this.orderInfo.items) {
                        for (let j in this.couponList) {
                            if (
                                i.itemtype != "N" &&
                                i.cardno == this.couponList[j].cardno
                            ) {
                                this.$set(
                                    this.couponList[j],
                                    "is_selected",
                                    true
                                );
                            }
                        }
                    }
                    let couponArr = [];
                    for (let i of this.couponList) {
                        if (i.is_selected) {
                            couponArr.push(i.cardno);
                        }
                    }
                    this.selectedCouponArr = couponArr;
                    this.selectedCouponNum = couponArr.length;
                }
            })
            .catch((error) => {
                console.log(error);
            });
    },
    methods: {
        getCouponInfo() {
            return new Promise((resolve, reject) => {
                this.$post({
                    method: "member.coupon.available.list",
                    auth_code: this.getLocal("auth_code"),
                    tradeno: this.tradeno,
                }).then((res) => {
                    resolve(res);
                    if (res.success) {
                        this.couponList = res.data.couponlist;
                        this.invalidCouponList = res.data.unusedcouponlist
                            ? res.data.unusedcouponlist
                            : [];
                    }
                });
            });
        },
        //  获取订单信息
        getOrderInfo() {
            return new Promise((resolve, reject) => {
                this.$post({
                    method: "member.order.get",
                    auth_code: this.getLocal("auth_code"),
                    tradeno: this.tradeno,
                }).then((res) => {
                    resolve(res);
                    this.orderInfo = res.data.order;
                });
            });
        },
        //  选择优惠券
        selectCoupon(index) {
            let couponArr = [];
            for (let i of this.couponList) {
                if (i.is_selected) {
                    couponArr.push(i.cardno);
                }
            }
            this.selectedCouponArr = couponArr;
            // if (this.isVipPay) {
            //     Toast({
            //         message: "优惠不可与贵宾卡同享",
            //         position: "middle",
            //         duration: 2000,
            //         className: "toastBox",
            //     });
            //     return;
            // }
            if (
                this.selectedCouponArr.length == this.ticketNum &&
                !this.couponList[index].is_selected
            ) {
                Toast({
                    message: "使用卡券的数量不能超过座位数",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                return;
            }
            this.$set(
                this.couponList[index],
                "is_selected",
                this.couponList[index].is_selected ? false : true
            );
            this.selectedCouponNum = this.couponList[index].is_selected
                ? this.selectedCouponNum + 1
                : this.selectedCouponNum - 1;
        },
        useCoupon() {
            let couponArr = [];
            for (let i of this.couponList) {
                if (i.is_selected) {
                    couponArr.push(i.cardno);
                }
            }
            // if (!couponArr.length) {
            //     Toast({
            //         message: "请先选择卡券",
            //         position: "middle",
            //         duration: 2000,
            //         className: "toastBox",
            //     });
            //     return;
            // }
            this.selectedCouponArr = couponArr;
            this.cardnos = this.selectedCouponArr.length ? this.selectedCouponArr.join(",") : "";
            this.$post({
                method: "member.order.coupon.modify",
                tradeno: this.tradeno,
                auth_code: this.getLocal("auth_code"),
                cardnos: this.cardnos,
            }).then((res) => {
                if (res.success) {
                    this.$router.back(-1);
                } else {
                    Toast({
                        message: res.error.desp,
                        position: "middle",
                        duration: 2000,
                        className: "toastBox",
                    });
                }
            });
            // this.showCoupons = false;
        },
    },
};
</script>
<style lang="scss">
.select_coupon_wrap {
    width: 100%;
    padding-bottom: 220px;
    div {
        width: 100%;
        .title {
            width: 90%;
            height: 80px;
            line-height: 80px;
            font-size: 24px;
        }
        .couponItem {
            width: 90%;
            height: 150px;
            margin: 0 auto 20px auto;
            padding: 0 30px;
            background-color: #fff;
            border-radius: 10px;
            position: relative;
            .selectedIco {
                position: absolute;
                right: 0;
                top: 0;
                width: 65px;
                height: 65px;
                background-color: #e42f46;
                border-top-right-radius: 10px;
                border-bottom-left-radius: 70px;
                img {
                    width: 38px;
                    height: 38px;
                }
            }
            .itemInfo {
                height: 150px;
                span {
                    font-size: 28px;
                    line-height: 40px;
                }
                .status {
                    min-width: 130px;
                    text-align: right;
                }
            }
        }
        .invalid_coupon {
            width: 90%;
            margin-bottom: 20px;
            .coupon_item {
                width: 100%;
                height: 150px;
                padding: 0 30px;
                background-color: #fff;
                border-radius: 10px 10px 0 0;
                position: relative;
                .invalid_icon {
                    position: absolute;
                    right: 36px;
                    top: 16px;
                    width: 122px;
                    height: 107px;
                }
                div {
                    height: 150px;
                    span {
                        font-size: 28px;
                        line-height: 40px;
                    }
                }
            }
            .coupon_footer {
                width: 100%;
                padding: 0 30px;
                box-sizing: border-box;
                background: #fff;
                border-radius: 0 0 10px 10px;
                border-top: 1px solid #dedede;
                height: 55px;
                line-height: 55px;
                font-size: 20px;
                color: #c11920;
            }
        }
    }
    .footer {
        width: 680px;
        height: 100px;
        position: fixed;
        bottom: 58px;
        left: 35px;
        background: #c11920;
        color: #fff;
        font-size: 28px;
        border-radius: 50px;
        span {
            margin-left: 50px;
        }
        div {
            width: 204px;
            height: 100px;
            border-left: 1px solid #fff;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/coupon/selectCoupon.vue